import type {ReactElement} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {SURVEY_FIELD_ERROR_ID_PREFIX} from '@Components/ai-chat-window/components/survey/survey.types';
import type {SelectFieldRendererProps} from './fields.types';
import {OptionCard} from './option-card';
import styles from './fields.module.scss';

function renderRadio(isSelected: boolean): ReactElement {
  return <span className={isSelected ? `${styles.radio} ${styles.radioSelected}` : styles.radio} />;
}

export function SelectFieldRenderer({name, step, field}: SelectFieldRendererProps): ReactElement {
  const {control} = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue=""
      render={({field: rhfField, fieldState}): ReactElement => {
        const current = typeof rhfField.value === 'string' ? rhfField.value : '';
        return (
          <div
            className={styles.optionList}
            role="radiogroup"
            aria-label={step.helpText}
            aria-invalid={fieldState.invalid || undefined}
            aria-describedby={fieldState.invalid ? `${SURVEY_FIELD_ERROR_ID_PREFIX}${name}` : undefined}
          >
            {field.options.map((opt) => {
              const isSelected = current === opt.value;
              return (
                <OptionCard
                  key={opt.value}
                  label={opt.label}
                  imageUrl={opt.imageUrl}
                  isSelected={isSelected}
                  leadingSlot={renderRadio(isSelected)}
                  onClick={(): void => {
                    rhfField.onChange(opt.value);
                  }}
                />
              );
            })}
          </div>
        );
      }}
    />
  );
}
